// Helper pour identifier les sections disponibles sur la page
window.ConditionalSectionHelper = {
  // Liste toutes les sections Shopify
  listAllSections: function() {
    const sections = [];
    document.querySelectorAll('.shopify-section').forEach(section => {
      const id = section.id;
      const classes = Array.from(section.classList).join(', ');
      const dataAttrs = {};

      Array.from(section.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
          dataAttrs[attr.name] = attr.value;
        }
      });

      sections.push({
        id: id,
        selector_by_id: `#${id}`,
        classes: classes,
        data_attributes: dataAttrs,
        element: section
      });
    });

    return sections;
  },

  // Affiche la liste dans la console de manière formatée
  printSectionsList: function() {
    const sections = this.listAllSections();

    console.group('📋 Sections disponibles sur la page (' + sections.length + ')');

    sections.forEach((section, index) => {
      // Extraire le type de section de l'ID
      const idParts = section.id.match(/shopify-section-(?:template--\d+__)?(.+?)(?:_[a-zA-Z0-9]+)?$/);
      const sectionType = idParts ? idParts[1] : section.id;
      const genericSelector = `[id*="${sectionType}"]`;

      console.group(`${index + 1}. ${section.id}`);
      console.log('Sélecteur par ID exact:', `#${section.id}`);
      console.log('Sélecteur générique (recommandé):', genericSelector);
      console.log('Type de section:', sectionType);
      console.log('Classes:', section.classes);
      if (Object.keys(section.data_attributes).length > 0) {
        console.log('Attributs data:', section.data_attributes);
      }
      console.groupEnd();
    });

    console.groupEnd();

    // Retourner aussi une liste de sélecteurs génériques
    console.log('\n📝 Sélecteurs GÉNÉRIQUES (fonctionnent partout) :');
    const genericSelectors = sections.map(s => {
      const idParts = s.id.match(/shopify-section-(?:template--\d+__)?(.+?)(?:_[a-zA-Z0-9]+)?$/);
      const sectionType = idParts ? idParts[1] : s.id;
      return `[id*="${sectionType}"]`;
    }).join(', ');
    console.log(genericSelectors);

    console.log('\n📝 Sélecteurs EXACTS (uniquement ce contexte) :');
    console.log(sections.map(s => `#${s.id}`).join(', '));

    return sections;
  },

  // Générer des sélecteurs CSS pour certaines sections
  generateSelectors: function(filter = {}) {
    const sections = this.listAllSections();
    const selectors = [];

    sections.forEach(section => {
      let match = true;

      // Filtrer par classe
      if (filter.hasClass && !section.classes.includes(filter.hasClass)) {
        match = false;
      }

      // Filtrer par attribut data
      if (filter.hasDataAttribute) {
        const [key, value] = filter.hasDataAttribute.split('=');
        if (!section.data_attributes[key] || (value && section.data_attributes[key] !== value)) {
          match = false;
        }
      }

      // Filtrer par ID contenant un texte
      if (filter.idContains && !section.id.includes(filter.idContains)) {
        match = false;
      }

      if (match) {
        selectors.push(`#${section.id}`);
      }
    });

    return selectors;
  },

  // Exemples d'utilisation
  examples: function() {
    console.log('💡 Exemples d\'utilisation:');
    console.log('');
    console.log('// Lister toutes les sections');
    console.log('ConditionalSectionHelper.printSectionsList()');
    console.log('');
    console.log('// Générer sélecteurs pour sections contenant "template"');
    console.log('ConditionalSectionHelper.generateSelectors({ idContains: "template" })');
    console.log('');
    console.log('// Générer sélecteurs pour sections avec classe spécifique');
    console.log('ConditionalSectionHelper.generateSelectors({ hasClass: "announcement-bar" })');
    console.log('');
    console.log('// Filtrer par attribut data');
    console.log('ConditionalSectionHelper.generateSelectors({ hasDataAttribute: "data-section-type=slideshow" })');
  }
};

// Bouton helper visible uniquement dans l'éditeur ou avec ?show_helper=1
if (window.Shopify && window.Shopify.designMode || window.location.search.includes('show_helper=1')) {
  document.addEventListener('DOMContentLoaded', function() {
    const helperBtn = document.createElement('button');
    helperBtn.innerHTML = '📋 Sections';
    helperBtn.style.cssText = 'position:fixed;bottom:20px;right:20px;z-index:99999;padding:12px 20px;background:#001e0a;color:white;border:none;border-radius:8px;cursor:pointer;font-weight:bold;box-shadow:0 4px 12px rgba(0,0,0,0.3);';

    helperBtn.onclick = function() {
      const sections = window.ConditionalSectionHelper.listAllSections();

      // Générer les sélecteurs génériques
      const genericSelectors = sections.map(s => {
        const idParts = s.id.match(/shopify-section-(?:template--\d+__)?(.+?)(?:_[a-zA-Z0-9]+)?$/);
        const sectionType = idParts ? idParts[1] : s.id;
        return `[id*="${sectionType}"]`;
      }).join(',\n');

      const modal = document.createElement('div');
      modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.8);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;';

      const content = document.createElement('div');
      content.style.cssText = 'background:white;padding:30px;border-radius:12px;max-width:800px;max-height:80vh;overflow:auto;';

      content.innerHTML = `
        <h2 style="margin-top:0;color:#001e0a;">📋 Sections disponibles (${sections.length})</h2>
        <p style="color:#666;margin-bottom:15px;"><strong>⚠️ Utilisez les sélecteurs GÉNÉRIQUES</strong> pour que ça fonctionne partout (admin et site)</p>
        <div style="margin-bottom:15px;">
          <label style="font-weight:bold;color:#001e0a;display:block;margin-bottom:5px;">Sélecteurs GÉNÉRIQUES (recommandé) :</label>
          <textarea id="genericSelectors" style="width:100%;height:150px;font-family:monospace;font-size:12px;padding:10px;border:2px solid #4CAF50;border-radius:6px;background:#f0fff4;">${genericSelectors}</textarea>
          <button onclick="navigator.clipboard.writeText(document.getElementById('genericSelectors').value);this.textContent='✓ Copié!';setTimeout(()=>this.textContent='Copier',2000)" style="margin-top:5px;padding:8px 16px;background:#4CAF50;color:white;border:none;border-radius:4px;cursor:pointer;">Copier</button>
        </div>
        <details style="margin-top:20px;">
          <summary style="cursor:pointer;font-weight:bold;color:#001e0a;padding:10px 0;">Voir les détails de chaque section</summary>
          <div style="margin-top:10px;max-height:300px;overflow:auto;">
            ${sections.map((s, i) => {
              const idParts = s.id.match(/shopify-section-(?:template--\d+__)?(.+?)(?:_[a-zA-Z0-9]+)?$/);
              const sectionType = idParts ? idParts[1] : s.id;
              return `
              <div style="padding:12px;margin:8px 0;background:#f5f5f5;border-radius:6px;">
                <strong style="color:#001e0a;">${i + 1}. ${sectionType}</strong><br>
                <span style="color:#666;font-size:11px;">Générique: [id*="${sectionType}"]</span><br>
                <span style="color:#999;font-size:10px;">ID exact: ${s.id}</span>
              </div>
            `}).join('')}
          </div>
        </details>
        <button onclick="this.closest('div[style*=fixed]').remove()" style="margin-top:20px;padding:12px 24px;background:#001e0a;color:white;border:none;border-radius:6px;cursor:pointer;font-weight:bold;">Fermer</button>
      `;

      modal.appendChild(content);
      modal.onclick = (e) => { if(e.target === modal) modal.remove(); };
      document.body.appendChild(modal);
    };

    document.body.appendChild(helperBtn);
  });
}

console.log('✅ Section Helper chargé !');
console.log('Tapez ConditionalSectionHelper.printSectionsList() pour voir toutes les sections');
